import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MaterialSwitch from '@material-ui/core/Switch';
import { FormControlLabel } from '@material-ui/core';
import styles from './Switch.scss';

const Switch = ({ className, label, labelPlacement, disabled, ...props }) =>
    <FormControlLabel
    className={classnames(styles.baseSwitch, className)}
    label={label}
    labelPlacement={labelPlacement}
    disabled={disabled}
    control={
        <MaterialSwitch {...props} />
    }
    />;
    
Switch.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    labelPlacement: PropTypes.string,
    disabled: PropTypes.bool
};

Switch.defaultProps = {
    labelPlacement: 'start'
};

export default Switch;

